  import React from "react";
  import useSessionVariables from "./useSessionVariables";

  function FormModal({ handleShowPopUpForm,formComponent:FormComponent,formProps }) {

    return (
      <div className="modal-overlay" >
        <div className="modal-content" >
        <button
        className="close-button"
        onClick={()=> handleShowPopUpForm("")}
      >
        &times;
      </button>

          <FormComponent {...formProps}
          />
        </div>
      </div>
    );
  }

  export default FormModal;
